import { render, staticRenderFns } from "./CtaPregnant.vue?vue&type=template&id=30b18493"
import script from "./CtaPregnant.vue?vue&type=script&lang=js"
export * from "./CtaPregnant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports